import { FullScreenModal } from "@/components/FullScreenModal"
import Stepper from "@/components/Stepper"
import StepperSection from "@/components/Stepper/StepperSection"
import type { PeopleJsonldReadItemPeople } from "@/networking/api"
import { isNotBlank } from "@/utils/ts-utils"
import { FormattedMessage, useIntl } from "react-intl"
import { useAddOrEditPeopleStepFormContext } from "./context/AddOrEditPeopleFormStepContext"
import { ContactDetailsStep } from "./steps/ContactDetailsStep"
import { GeneralStep } from "./steps/GeneralStep"

type Props = {
  isOpen: boolean
  onClose: (people?: PeopleJsonldReadItemPeople) => void
}

export const EditPeopleModal: React.FC<Props> = ({ isOpen, onClose }) => {
  const intl = useIntl()
  const steps = [
    { label: intl.formatMessage({ id: "client.modalEdit.generalStep.title" }) },
    { label: intl.formatMessage({ id: "client.modalEdit.generalStep.coords" }) },
  ]

  const { formStep1State } = useAddOrEditPeopleStepFormContext()
  const titleId =
    "id" in formStep1State && isNotBlank(formStep1State.id)
      ? "client.editPeople"
      : "client.addPeople"

  return (
    <FullScreenModal
      isOpen={isOpen}
      onClose={onClose}
      title={<FormattedMessage id={titleId} />}
      maxWidth="850px"
    >
      <Stepper steps={steps}>
        <StepperSection index={0}>
          <GeneralStep />
        </StepperSection>
        <StepperSection index={1}>
          <ContactDetailsStep onClose={onClose} />
        </StepperSection>
      </Stepper>
    </FullScreenModal>
  )
}
